import React, { PropTypes } from 'react';
import Page from '../../Page';


class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnswer: ''
    };
    this.onSelectAnswer = this.onSelectAnswer.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedAnswer: ''
    });
  }

  onSelectAnswer(answer) {
    this.setState({
      selectedAnswer: answer
    });
  }

  render() {
    const { value: { question, alternatives, labelBefore, labelAfter, commentAfter, dontKnow,  description } } = this.props;
    const { selectedAnswer } = this.state;
    const hasAnswered = !!selectedAnswer;
    const styles = require('./Question.scss');

    return (
      <div className={styles.wrapper}>
        <div className={styles.question_wrapper}>
          <h2 className={styles.question}>{question}</h2>
        </div>
        <h3 className={styles.alternatives_label}>{hasAnswered ? labelAfter : labelBefore}</h3>
        <ul className={styles.alternatives}>
          {alternatives.map((alternative, i) => {
            if(!hasAnswered) {
              return (
                <li key={i} className={styles.alternative}>
                    <button
                      onClick={() => this.onSelectAnswer(alternative.answer)}
                      className={styles.button}
                    >
                      {alternative.answer}
                    </button>
                </li>
              );
            } else {
              const isSelected = alternative.answer === selectedAnswer;
              return (
                <li key={i} className={isSelected ? styles.alternative_selected : styles.alternative}>
                  <div className={styles.presentation}>
                    <h5 className={styles.presentation_label}>{alternative.answer}</h5>
                    <p>{alternative.agrees.map((agree, j) =>
                      <span key={agree.name} className={styles.agree}>{agree.name}{j < alternative.agrees.length - 1 && <span className={styles.agreecomma}>, </span>}</span>
                    )}</p>
                  </div>
                </li>
              );
            }
          })}
          {!hasAnswered && dontKnow && alternatives[alternatives.length - 1].answer !== dontKnow &&
          <li key="dontKnow" className={styles.alternative}>
            <button
              onClick={() => this.onSelectAnswer('dontKnow')}
              className={styles.button}
            >
              {dontKnow}
            </button>
          </li>
          }
        </ul>
        { commentAfter && <p className={styles.commentAfter}>{commentAfter}</p> }
        <Page className={styles.description} data={description}/>
      </div>
    );
  }


}

Question.propTypes = {
  value: PropTypes.shape({
    question: PropTypes.string,
    alternatives: PropTypes.arrayOf(
      PropTypes.shape({
        answer: PropTypes.string,
        agrees: PropTypes.array
      }),
    ),
    labelBefore: PropTypes.string,
    labelAfter: PropTypes.string,
    description: PropTypes.array

  })
};



export default Question;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/InfoQuiz/Question.js
 **/